import Image from 'next/image'

import Facebook from 'components/social/facebook'
import Twitter from 'components/social/twitter'
import Instagram from 'components/social/instagram'
import Linkedin from 'components/social/linkedin'

export default function AuthorBox({ authorData }) {
  return (
    <footer className="relative border border-orange">
      <div className="absolute -top-8 right-4 z-0">
        <h2 className="font-serif text-5xl font-bold text-yellow opacity-50">Auteur</h2>
      </div>
      <div className="relative z-10 bg-backgroundLight px-4 py-5 sm:p-6">
        <div className="flex items-center space-x-4">
          <div className="h-14 w-14 flex-none overflow-hidden rounded-full">
            <Image
              src={authorData.node.avatar.url}
              width={500}
              height={500}
              alt={`Avatar de ${authorData.node.name}`}
            />
          </div>
          <div className="flex flex-col justify-center">
            <h3 className="text-lg font-medium">{authorData.node.name}</h3>
            <h4 className="-mt-1 text-sm text-gray-500">{authorData.node?.author_role?.role}</h4>
          </div>
        </div>
        {authorData.node.description ? <p className="mt-2 text-gray-800">{authorData.node.description}</p> : null}
        <ul className="mt-4 flex items-center space-x-4">
          <SocialLink socialMedia="website" link={authorData.node.seo.social?.mySpace} />
          <SocialLink
            socialMedia="twitter"
            link={
              authorData.node.seo.social?.twitter ? 'https://twitter.com/' + authorData.node.seo.social?.twitter : null
            }
          />
          <SocialLink socialMedia="instagram" link={authorData.node.seo.social?.instagram} />
          <SocialLink socialMedia="linkedin" link={authorData.node.seo.social?.linkedIn} />
          <SocialLink socialMedia="facebook" link={authorData.node.seo.social?.facebook} />
        </ul>
      </div>
    </footer>
  )
}

const SocialLink = ({ socialMedia, link }) =>
  link ? (
    <li>
      <a href={link} target="_blank" rel="noreferrer noopener" className="text-gray-400">
        {socialMedia === 'website' ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-4" fill="currentColor">
            <path d="M256 64c0-17.67 14.3-32 32-32h127.1c5.2 0 9.4.86 13.1 2.43 2.9 1.55 7.3 3.84 10.4 6.87 0 .05 0 .1.1.14 6.2 6.22 8.4 14.34 9.3 22.46V192c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50.7L214.6 310.6c-12.5 12.5-32.7 12.5-45.2 0s-12.5-32.7 0-45.2L338.7 96H288c-17.7 0-32-14.33-32-32zM0 128c0-35.35 28.65-64 64-64h96c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32H64v288h288v-96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V128z"></path>
          </svg>
        ) : null}
        {socialMedia === 'facebook' ? <Facebook className="h-4" /> : null}
        {socialMedia === 'twitter' ? <Twitter className="h-4" /> : null}
        {socialMedia === 'linkedin' ? <Linkedin className="h-4" /> : null}
        {socialMedia === 'instagram' ? <Instagram className="h-5" /> : null}
      </a>
    </li>
  ) : null
